import { create } from 'zustand';

interface UpgradeRequiredState {
  isUpgradeRequired: boolean;
  currentVersion: string;
  minVersion: string;
  updateUrl: string;
}

interface UpgradeRequiredActions {
  setUpgradeRequired: (
    currentVersion: string,
    minVersion: string,
    updateUrl: string
  ) => void;
}

type UpgradeRequiredStore = UpgradeRequiredState & UpgradeRequiredActions;

export const useUpgradeRequiredStore = create<UpgradeRequiredStore>((set) => ({
  // State
  isUpgradeRequired: false,
  currentVersion: '',
  minVersion: '',
  updateUrl: '',

  // Actions
  setUpgradeRequired: (currentVersion, minVersion, updateUrl) => {
    set({
      isUpgradeRequired: true,
      currentVersion,
      minVersion,
      updateUrl,
    });
  },
}));

// Initialize event listener on client side
if (typeof window !== 'undefined') {
  window.addEventListener('upgrade-required', ((event: CustomEvent) => {
    const { currentVersion, minVersion, updateUrl } = event.detail;
    useUpgradeRequiredStore
      .getState()
      .setUpgradeRequired(currentVersion, minVersion, updateUrl);
  }) as EventListener);
}
